import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import RFIDModule from "modules/plc/rfid/rfid.module";

const RFIDPage = () => {
  return (
    <Switch>
      <Route exact path={Path.RFID} component={RFIDModule} />
      <Redirect to={Path.RFID} />
    </Switch>
  );
};

export default RFIDPage;
